import styled from '@emotion/styled';

import COLOR from '../../../../shared/constant/colorset';

import { useAppSelector } from '../../../../shared/store';
import { ProductAvailableSort } from '../../types';
import RecommendView from './RecommendView';

const ListAbility = styled.div`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 18px 0 16px;
`;

const TotalPagingCount = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${COLOR.kurlyGray800};
`;

const SortList = styled.ul`
  position: relative;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
`;

const SortItem = styled.li`
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: end;
  justify-content: flex-end;
  height: 24px;
  margin-left: 8px;
  font-size: 12px;
  color: ${COLOR.kurlyGray450};
  cursor: pointer;

  &:first-of-type {
    margin-right: -4px;
    &:before {
      display: none;
    }
  }

  &:before {
    content: '';
    display: flex;
    width: 1px;
    height: 10px;
    margin-right: 8px;
    background-color: ${COLOR.kurlyGray250};
  }
`;

const SortLink = styled.a<{ isCurrent: boolean; }>`
  letter-spacing: -0.3px;
  ${({ isCurrent }) => (isCurrent
    ? `font-weight: 500;color: ${COLOR.kurlyGray800};`
    : ''
  )}
`;

interface Props {
  onChangeSort: (sort: ProductAvailableSort)=> void;
}

export default function Sort({
  onChangeSort,
}: Props) {
  const {
    section,
    sort,
    pagination,
  } = useAppSelector(({ productList }) => productList);
  const { item, selectedType } = sort;

  return (
    <ListAbility>
      <TotalPagingCount>{`총 ${pagination.totalProductsCount}개`}</TotalPagingCount>

      <SortList>
        {item.map((it) => (
          <SortItem key={it.type}>
            <SortLink
              isCurrent={it.type === selectedType}
              onClick={() => onChangeSort(it)}
            >{it.name}</SortLink>
            {it.name === '추천순' && (
              <RecommendView section={section} />
            )}
          </SortItem>
        ))}
      </SortList>
    </ListAbility>
  );
}
